module.exports = "/_next/static/images/staff-cf49b9c03a90a885e5cf6e9555f0e0cc.jpg";